/** @jsxImportSource @emotion/react */
import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

type Props = {
	value: string | undefined
	onChange: (next: string) => void
	className?: string
}

/**
 * 사이드 필터 패널 전용 연도 캘린더 피커.
 * - value/onChange는 string (빈 문자열 = 미선택).
 * - 내부에서 Date로 변환하여 DatePicker(views=['year'])에 연결.
 *   프로젝트 전역 date adapter가 date-fns 이므로 여기서도 AdapterDateFns 를 쓴다.
 */
export const YearFilterPicker = ({ value, onChange, className }: Props) => {
	const dateValue: Date | null =
		value && value !== '' ? new Date(Number(value), 0, 1) : null

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DatePicker
				className={className}
				value={dateValue}
				onChange={(next: Date | null) =>
					onChange(
						next && !Number.isNaN(next.getTime()) ? String(next.getFullYear()) : '',
					)
				}
				views={['year']}
				openTo="year"
				format="yyyy"
				slotProps={{
					textField: {
						size: 'small',
						placeholder: '전체',
						fullWidth: true,
					},
					field: { clearable: true } as any,
				}}
			/>
		</LocalizationProvider>
	)
}
